/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportTypeCodeUIDTOV0 } from './reportTypeCodeUIDTOV0';
import { SapCountryCodesV0 } from './sapCountryCodesV0';


export interface RdSAPSurveyDetailsDtoUIDTOV0 { 
    /**
     * `RdSAP Assessment Report` Number. The Unique Id & primary index for storage. This value is globally unique.
     */
    readonly reportReferenceNumber: string;
    /**
     * Version of the survey details.
     */
    version: string;
    /**
     * Accreditation scheme for the assessor.
     */
    accreditationScheme: string;
    /**
     * Identifier for the assessor.
     */
    readonly assessorId: string;
    /**
     * Name of the assessor.
     */
    assessorName: string;
    /**
     * Date when the inspection took place.
     */
    inspectionDate: string;
    /**
     * Date when the certification was issued.
     */
    readonly certificationDate?: string;
    /**
     * Revision number for the PCDF.
     */
    readonly pcdfRevisionNumber?: number;
    reportType?: ReportTypeCodeUIDTOV0;
    /**
     * The language this report is written in. \'1\' for English, \'2\' for Welsh.
     */
    languageCode?: RdSAPSurveyDetailsDtoUIDTOV0.LanguageCodeEnum;
    /**
     * Name of the software used to perform the SAP calculation.
     */
    calculationSoftwareName: string;
    /**
     * Version of the software used to perform the SAP calculation.
     */
    calculationSoftwareVersion: string;
    /**
     * The version of the user interface used for data entry. This can be the same as Calculation-Software-Version, or different.
     */
    readonly userInterfaceVersion?: string;
    /**
     * The name of the user interface used for data entry. This can be the same as Calculation-Software-Name, or different.
     */
    readonly userInterfaceName?: string;
    /**
     * The schema version that the data conformed to when it was lodged.
     */
    readonly schemaVersionOriginal?: string;
    /**
     * The schema version to which the data conforms. This node is inserted by the register when a retrieval is requested. It must not be present in a lodgement being sent to the register.
     */
    readonly schemaVersionCurrent?: string;
    countryCode: SapCountryCodesV0;
    /**
     * |- 1. No related party 2. Relative of homeowner or of occupier of the property 3. Residing at the property 4. Financial interest in the property 5. Owner or Director of the organisation dealing with the property transaction 6. Employed by the professional dealing with the property transaction 7. Relative of the professional dealing with the property transaction 
     */
    relatedPartyDisclosureNumber?: RdSAPSurveyDetailsDtoUIDTOV0.RelatedPartyDisclosureNumberEnum;
    /**
     * total floor area of the property.
     */
    readonly totalFloorArea?: number;
}
export namespace RdSAPSurveyDetailsDtoUIDTOV0 {
    export type LanguageCodeEnum = '1' | '2';
    export const LanguageCodeEnum = {
        _1: '1' as LanguageCodeEnum,
        _2: '2' as LanguageCodeEnum
    };
    export type RelatedPartyDisclosureNumberEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7';
    export const RelatedPartyDisclosureNumberEnum = {
        _1: '1' as RelatedPartyDisclosureNumberEnum,
        _2: '2' as RelatedPartyDisclosureNumberEnum,
        _3: '3' as RelatedPartyDisclosureNumberEnum,
        _4: '4' as RelatedPartyDisclosureNumberEnum,
        _5: '5' as RelatedPartyDisclosureNumberEnum,
        _6: '6' as RelatedPartyDisclosureNumberEnum,
        _7: '7' as RelatedPartyDisclosureNumberEnum
    };
}


